/**
 * @file Resize assignment
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { ResizeBase } from './resize';
var AssignmentResize = /** @class */ (function (_super) {
    tslib_1.__extends(AssignmentResize, _super);
    /**
     * Creates an instance of AssignmentResize.
     */
    function AssignmentResize(domainService, overlayService, dropTargetsService, diaglogService, translateService, userService, resourceService) {
        return _super.call(this, 'assignment-resize', 'APP.EXECUTORS.ASSIGNMENT_RESIZE_NAME', ['Assignment'], 'Assignment', domainService, overlayService, dropTargetsService, diaglogService, translateService, userService, resourceService) || this;
    }
    /**
     * The business logic for this executor and is executed after the
     * validation step and before the finish step.
     * @param {ExecutorData} data The executor data
     * @returns {Promise<any>}
     */
    AssignmentResize.prototype.process = function (data) {
        var _this = this;
        // Your magic here inside an async promise
        return new Promise(function (resolve, reject) {
            _this.explodeExecutorData(data).forEach(function (slice) {
                _this.resizeAssignment(slice.item, slice.target);
            });
            _this.subscriptionPool.add(_this.trySaveChanges(reject).subscribe(function (result) {
                resolve(result.entities);
            }));
        });
    };
    /**
     * Resize the assignment
     * @private
     * @param {Entity} item The entity
     * @param {ExecutorTimeslot} target The target timeslot
     */
    AssignmentResize.prototype.resizeAssignment = function (item, target) {
        // Fix Issue: Uren assignment verandert bij resize #2483
        // Doen we niet meer, is werkdruk planning en leidt tot verwarring.
        // const oldDuration = moment(item['Finish']).diff(moment(item['Start']));
        // const newDuration = target.finish.diff(target.start);
        // const factor = newDuration / oldDuration;
        item['Finish'] = target.finish.toDate();
        item['Start'] = target.start.toDate();
        // item['Effort'] = moment.duration(moment.duration(item['Effort']).asMinutes() * factor, 'minutes').toISOString();
    };
    return AssignmentResize;
}(ResizeBase));
export { AssignmentResize };
